export default __webpack_public_path__ + "e769a7b90435a4adf52beca51a7ece1d.svg";